export const GOOGLE_ID = "AIzaSyCM-BDh-MKpSZtivA5YOmgDSkght8mhTw0";
export const GEO_URI =
  "https://maps.googleapis.com/maps/api/geocode/json?address=";

export const GOOGLE = {
  geo_code_uri: "https://maps.googleapis.com/maps/api/geocode/json?address=",
  geo_code: address => `${GEO_URI}${address}&key=${GOOGLE_ID}&components=country:UK`,
  map_url: `https://maps.googleapis.com/maps/api/js?v=3.27&key=${GOOGLE_ID}`
};

export const POLICE_ROOT = "https://data.police.uk/api/";
export const POLICE = {
  api: "http://data.police.uk/api/",
  availability: `${POLICE_ROOT}crimes-street-dates`,
  crimes_by_location: data => `${POLICE_ROOT}crimes-street/all-crime?lat=${data.lat}&lng=${data.lng}&date=${data.date}`,
  crimes_by_area: (latlngs, date) => `
  ${POLICE_ROOT}crimes-street/all-crime?poly=${latlngs.join(",")}&date=${date}`,
  crimes_by_hood: `${POLICE_ROOT}crimes-street/all-crime`,
  categories: date => `${POLICE_ROOT}crime-categories?date=${date}`,
  area_boundary: (force, zone) => `${POLICE_ROOT}${force}/${zone}/boundary`,
  neighbourhood: (force, zone) => `${POLICE_ROOT}${force}/${zone}`,
  neighbourhoods_by_force: force => `${POLICE_ROOT}${force}/${force}`,
  neighbourhood_team: (force, zone) => `${POLICE_ROOT}${force}/${zone}/people`,
  neighbourhood_events: (force, zone) => `${POLICE_ROOT}${force}/${zone}/events`,
  neighbourhood_priorities: (force, zone) => `
  ${POLICE_ROOT}${force}/${zone}/priorities`,
  locate_neighbourhood: (lat, lng) => `
  ${POLICE_ROOT}locate-neighbourhood?q=${lat},${lng}`,
  forces: `${POLICE_ROOT}forces`,
  force: force => `${POLICE_ROOT}force/${force}`,
  searches_by_location: (lat, lng, date) => `
  ${POLICE_ROOT}crimes-street/stop-street?lat=${lat}&lng=${lng}=${date}`,
  searches_by_area: (latlngs, date) => `
  ${POLICE_ROOT}stop-street?poly=${latlngs.join(",")}&date=${date}`,
  searches_by_force: (force, date) => `
  ${POLICE_ROOT}stop-force?force=${force}&date=${date}`
};

export const SEARCH = {
  crimes_by_location: "crimes_by_location",
  req_coords: "req_coords",
  res_coords: "res_coords",
  res_boundary: "res_boundary",
  req_crime_by_location: "req_crime",
  res_crime_by_location: "res_crime_by_location",
  err_crime_by_location: "err_crime_by_location",
  res_categories: "res_categories",
  availability: "availability",
  req_availability: "req_availability",
  res_availability: "res_availability",
  err_availability: "err_availability",
  toggle_advanced: "toggle_advanced",
  change_date: "change_date",
  no_address: "no_address",
  show_search: "show_search",
  select_incidents: "select_incidents"
};

// export const SEARCH_CRIME_BY_LOCATION = "SEARCH_CRIME_BY_LOCATION";
// export const FETCH_COORDS = "FETCH_COORDS";
// export const FETCHED_CRIMES_BY_LOCATION = "FETCHED_CRIMES_BY_LOCATION";
// export const FETCH_CRIMES_BY_LOCATION_ERROR = "FETCH_CRIMES_BY_LOCATION_ERROR";



// WEBPACK FOOTER //
// ./src/constants/index.js